<template>
  <div class="row">
    <div class="col-xl-12 col-xs-12 vcenter" >
      <div class="form-middle" v-if="!loader">
        <div class="title-form">
            <h1>Retrieve Password</h1>
            <span class="bigger"> </span>
        </div>
        <div>
          <div class="w-form">
            <form id="email-form" @submit.prevent="resetPassword" name="email-form" data-name="Email Form">
              <flash-message></flash-message>
              <div class="field">
                <input type="email" v-model="form.email" placeholder="name@example.com" class="input-form" required>
                <label for="email">Email address</label>
              </div>
              <input type="submit" value="Reset my password" class="btn btn-large"></form>
          </div>
        </div>
      </div>
      <div v-if="loader">
        <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
  name: 'forgot_password',
  mounted () {
    this.messageStorage.destroyAll()
  },
  data () {
    return {
      form: {
        email: ''
      },
      messageStorage: this.flash()
    }
  },
  methods: {

    ...mapMutations([
      'user/changeLoaderState'
    ]),

    resetPassword: function () {
      this['user/changeLoaderState'](true)
      this.$http.post('/api/user/reset_password', this.form).then((res) => {
        this.messageStorage.destroyAll()
        this.messageStorage.flash('Email sent!', 'success')
        // redirect to passwordsent page
        this.$router.push({ name: 'password_sent', params: { email: this.form.email } })
        this['user/changeLoaderState'](false)
      }).catch((err) => {
        this.messageStorage.destroyAll()
        this.messageStorage.flash(err.data.error, 'error')
        this['user/changeLoaderState'](false)
      })
    }
  },
  computed: {
    loader: function () {
      return this.$store.state.user.loader
    }
  }
}
</script>
